import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { ClearSectionDialogProps } from './FormSection.types';

export const ClearSectionDialog = React.memo(function ClearSectionDialog({
  title,
  isOpen,
  onCancel,
  onConfirm,
}: ClearSectionDialogProps) {
  return (
    <Dialog open={isOpen} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>Подтверждение очистки</DialogTitle>
      <DialogContent>
        <Typography>
          Вы уверены, что хотите очистить все поля в разделе "{title}"? Это действие нельзя
          отменить.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary">
          Отмена
        </Button>
        <Button onClick={onConfirm} color="warning" variant="contained">
          Очистить
        </Button>
      </DialogActions>
    </Dialog>
  );
});
